export default __webpack_public_path__ + "static/media/title-modal-body.153f4d4c.svg";